import React from 'react';
import { connect } from 'react-redux';
import QRCode from 'qrcode';
import style from './index.less';
import { transform, i18n, lan } from '../../unit/const';
import { isMobile } from '../../unit';

// 消息ID生成器
var messageIdCounter = 0;

class Guide extends React.Component {
  constructor() {
    super();
    this.state = {
      isMobile: isMobile(),
      QRCode: '',
      messages: [],  // 消息列表：[{id, text, phase}]
    };
    this.timers = {};
  }
  componentWillMount() {
    if (this.state.isMobile) {
      return;
    }
    QRCode.toDataURL(location.href, { margin: 1 })
        .then(dataUrl => this.setState({ QRCode: dataUrl }));
  }
  componentDidMount() {
    var self = this;
    // 注册消息回调
    var setupCallback = function() {
      window.__tetrisMessageCallback = function(msg) {
        self.addMessage(msg);
      };
    };

    if (window.__tetrisMessages !== undefined) {
      setupCallback();
    } else {
      setTimeout(setupCallback, 1000);
    }
  }
  addMessage(text) {
    var self = this;
    var id = ++messageIdCounter;

    // 添加新消息
    this.setState(function(prevState) {
      return {
        messages: prevState.messages.concat([{
          id: id,
          text: text,
          phase: 'show'  // show -> float -> gone
        }])
      };
    });

    // 1秒后开始飘走
    this.timers[id] = {
      float: setTimeout(function() {
        self.setMessagePhase(id, 'float');
      }, 1000),
      remove: setTimeout(function() {
        self.removeMessage(id);
      }, 3500)  // 1秒显示 + 2.5秒飘走动画
    };
  }
  setMessagePhase(id, phase) {
    this.setState(function(prevState) {
      return {
        messages: prevState.messages.map(function(msg) {
          if (msg.id === id) {
            return Object.assign({}, msg, { phase: phase });
          }
          return msg;
        })
      };
    });
  }
  removeMessage(id) {
    // 清理定时器
    if (this.timers[id]) {
      clearTimeout(this.timers[id].float);
      clearTimeout(this.timers[id].remove);
      delete this.timers[id];
    }
    // 从状态中移除
    this.setState(function(prevState) {
      return {
        messages: prevState.messages.filter(function(msg) {
          return msg.id !== id;
        })
      };
    });
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.messages !== this.state.messages) return true;
    if (nextState.QRCode !== this.state.QRCode) return true;
    if (nextProps.pause !== this.props.pause) return true;
    return false;
  }
  componentWillUnmount() {
    // 清理所有定时器
    Object.keys(this.timers).forEach(function(id) {
      clearTimeout(this.timers[id].float);
      clearTimeout(this.timers[id].remove);
    }.bind(this));
  }
  render() {
    if (this.state.isMobile) {
      return null;
    }

    var self = this;

    // 渲染消息气泡
    var renderMessages = function() {
      var items = self.state.messages.map(function(msg) {
        var phaseClass = '';
        if (msg.phase === 'float') {
          phaseClass = style.floatAway;
        }
        return React.createElement('div', {
          key: msg.id,
          className: style.bubble + ' ' + phaseClass
        }, [
          React.createElement('span', { key: 'icon', className: style.bubbleIcon }, '🤔'),
          React.createElement('span', { key: 'text', className: style.bubbleText }, msg.text)
        ]);
      });

      // 如果暂停且没有消息，显示默认提示（也会飘走）
      if (self.props.pause && items.length === 0) {
        items.push(React.createElement('div', {
          key: 'default',
          className: style.bubble + ' ' + style.defaultBubble
        }, [
          React.createElement('span', { key: 'icon', className: style.bubbleIcon }, '🤔'),
          React.createElement('span', { key: 'text', className: style.bubbleText }, '我要停下来想想')
        ]));
      }

      return items;
    };

    return (
      <div style={{ display: this.state.isMobile ? 'none' : 'block' }}>
        <div className={`${style.guide} ${style.right}`}>
          <div className={style.up}>
            <em style={{ [transform]: 'translate(0,-3px) scale(1,2)' }} />
          </div>
          <div className={style.left}>
            <em style={{ [transform]: 'translate(-7px,3px) rotate(-90deg) scale(1,2)' }} />
          </div>
          <div className={style.down}>
            <em style={{ [transform]: 'translate(0,9px) rotate(180deg) scale(1,2)' }} /></div>
          <div className={style.right}>
            <em style={{ [transform]: 'translate(7px,3px)rotate(90deg) scale(1,2)' }} />
          </div>
        </div>
        <div className={`${style.guide} ${style.left}`}>
          {/* 消息气泡容器 - 在 SPACE 上方 */}
          <div className={style.messageArea}>
            {renderMessages()}
          </div>
          <div className={style.space}>SPACE</div>
        </div>
        { this.state.QRCode !== '' ? (
          <div className={`${style.guide} ${style.qr}`}>
            <img
              src={this.state.QRCode}
              alt={i18n.QRCode[lan]}
            />
          </div>
        ) : null }
      </div>
    );
  }
}

Guide.propTypes = {
  pause: React.PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  pause: state.get('pause'),
});

export default connect(mapStateToProps)(Guide);


// WEBPACK FOOTER //
// ./src/components/guide/index.js